import { STOCK_LOG_FETCH_SUCCESS, STOCK_LOGS_TABLE_UPDATE } from "../types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { IGPTable } from "ui/Table/Table";
import { AnyAction } from "redux";
import { MANAGE_TABLE } from "app/ManageTables/types";

function StockLogsTableReducer(
    state: IGPTable = {
        id: "StockLogsTable",
        columns: [],
        pagination: {
            isLastPage: true,
            page: 1,
            per_page: 20,
            total: 0,
        },
        search: "",
        sort: { created_at: "desc" },
    },
    action: AnyAction
) {
    switch (action.type) {
        case STOCK_LOG_FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;
        case STOCK_LOGS_TABLE_UPDATE:
            return tableUpdate(state, action);

        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;

        default:
            return state;
    }
}

export default StockLogsTableReducer;
